import { validationMixin as baseValidationMixin } from 'vuelidate'
import defaultTips from './tips'
import VdTips from './VdTips'
export * from './validators'

// 基于vuelidate校验器的二次封装
// https://monterail.github.io/vuelidate

export const validationMixin = ({
  errClass = 'vuelidaters-error',
  tipsType = 'alert'
} = {}) => {
  return {
    mixins: [baseValidationMixin],
    methods: {
      validationTouch($v = this.$v) {
        return new Promise((resolve, reject) => {
          this.$v.$touch()
          this.$nextTick(() => {
            if (this.$v.$error) {
              const { tips, type = tipsType } = this._getValidatorError($v)
              if (type === 'alert') this.$message(tips)
              reject(tips)
            } else {
              resolve()
            }
          })
        })
      },
      validationReset() {
        this.$v.$reset()
      },
      _getValidatorError($v) {
        const flattenParams = $v.$flattenParams()
        const validators = this.validators || this.$options.validators || {}
        for (const v of flattenParams) {
          const paramsType = v.params.type
          const validatorInstance = getValueByPath($v, v.path)
          if (!validatorInstance[paramsType]) {
            let customTips
            let validatorTipsType
            if (validators) {
              const validator = getValueByPath(
                validators,
                v.path.concat(v.name)
              )
              if (typeof validator === 'object') {
                customTips = validator.tips
                validatorTipsType = validator.type
              } else {
                customTips = validator
              }
              if (typeof customTips === 'function') {
                customTips = customTips(v.params)
              }
            }
            let defaultTip = defaultTips[paramsType]
            if (typeof defaultTip === 'function') {
              defaultTip = defaultTip(v.params)
            }
            const resultTips =
              customTips ||
              defaultTip ||
              `未定义${paramsType}的默认提示, 字段为${v.path.join('.')}`
            return { type: validatorTipsType, tips: resultTips }
          }
        }
        return { tips: '未知错误' }
      }
    },
    components: {
      VdTips
    }
  }
}

export function getValueByPath(obj, path = []) {
  if (typeof path === 'string') {
    path = path.split('.')
  }
  return path.reduce((prev, curr) => {
    return prev[curr] || {}
  }, obj)
}
